import Marquee from "react-fast-marquee";

const items = [
  "Where Property Meets Purpose",
  "Strategic Connector",
  "People · Property · Possibility",
  "Ethical. Sustainable. Considered.",
  "Investors · Developers · Providers",
];

export default function MarqueeBand() {
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-plum py-16 md:py-24 border-y border-gold/10 overflow-hidden"
      aria-label="Signature manifesto marquee"
    >
      <Marquee
        gradient={false}
        speed={28}
        pauseOnHover
        autoFill
        aria-hidden
        className="select-none"
      >
        {items.map((text, i) => (
          <span
            key={i}
            className="flex items-center gap-14 md:gap-20 pr-14 md:pr-20 font-serif italic text-6xl sm:text-7xl md:text-8xl lg:text-9xl leading-none"
          >
            <span className={i % 2 === 0 ? "text-cream" : "stroke-text"}>
              {text}
            </span>
            <span className="text-gold text-4xl md:text-6xl not-italic font-sans">
              ✦
            </span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
